import * as React from "react";

import { useAuthContextStore } from "@/features/auth/services/auth-context-store";

export function useNotificationWorkspaceLabelMap() {
  const authMe = useAuthContextStore((state) => state.authMe);

  return React.useMemo(() => {
    const labels = new Map<string, string>();

    for (const access of authMe?.workspaceAccess ?? []) {
      const workspace = access.workspace;
      if (!workspace?.id) continue;
      labels.set(workspace.id, workspace.displayName?.trim() || workspace.name || workspace.slug);
    }

    return labels;
  }, [authMe?.workspaceAccess]);
}
